import { Form } from "react-bootstrap";
import { IMaskInput } from 'react-imask';
import { reducerActions } from "../../../Reducers/FormReducer";

const Date_mm_dd_yyyy_Base = (props) => {
 
  const {
      field,
      objectkey,      
      dispatchState
    } = props;


  const handleAccept = (value) => {
    dispatchState({ 
      type: reducerActions.ON_CHANGE_TEXTBOX, 
      payload: { 
        key:objectkey,
        value: value 
      } 
    });    
    
  };

  const handleBlur = () => {
      dispatchState({
        type: reducerActions.ON_BLUR_DATE_MM_DD_YYYY,
          payload: { 
            key:objectkey       
          } 
      });      
  };

  return (
    <>
      <label htmlFor={field.fieldId}>
        {field.fieldLabel || field.fieldName}
        {field.fieldRequired && <span className="text-danger">*</span>}
        &nbsp;
      </label>

      <span className="input-wrapper date-mm-dd-yyyy">
       <Form.Group controlId={field.fieldId}>
        <Form.Control
          as={IMaskInput}
          mask="00-00-0000"
          value={field.fieldValue || ""}
          onAccept={handleAccept}
          onBlur={handleBlur}
          placeholder="MM-DD-YYYY"
          required={field.fieldRequired}
          isInvalid={!!field.isTouched && (field.isValid === false || !!field.error)}
        />
        <Form.Control.Feedback type="invalid">
          {field.error}
        </Form.Control.Feedback>
      </Form.Group>
      </span>
    </>
  );
};

export default Date_mm_dd_yyyy_Base;